import userService from '../../services/userService'
import portfolioService from '../../services/portfolioService'
import router from '../../router'

const role = 'admin'

const state = {
  users: [],
  usersPage: 1,
  usersTotal: 0,
  clients: [],
  clientsPage: 1,
  clientsTotal: 0,
  client: null,
  csrfToken: null,
  loggedUser: null,
}

const getters = {
  getLoggedUser: (state) => state.loggedUser,
  getToken: (state) => state.csrfToken,
  getUsersTotal: (state) => state.usersTotal,
  getUsers: (state) => (page) => {
    return (page === state.usersPage) ? state.users : []
  },
  getClientsTotal: (state) => state.clientsTotal,
  getClients: (state) => (page) => {
    return (page === state.clientsPage) ? state.clients : []
  },
  getClient(state) {
    return state.client
  },
}

const mutations = {
  // Becomes complicated when combined with list pagination
  // createUser(state, payload) {
  //   state.users.push(payload)
  // },
  // createClient(state, payload) {
  //   state.clients.push(payload)
  // },
  setUsers(state, {users, total, page}) {
    state.users = users
    state.usersTotal = total
    state.usersPage = page
  },
  setClients(state, {users, total, page}) {
    state.clients = users
    state.clientsTotal = total
    state.clientsPage = page
  },
  setClient(state, payload) {
    state.client = payload
  },
  login(state, payload) {
    state.csrfToken = payload.csrfToken
    state.loggedUser = payload.user
  },
  logout(state) {
    state.csrfToken = null
    state.loggedUser = null
  },
  setClientGroups(state, payload) {
    state.client.cgroups = payload
  },
}

const actions = {
  loadUsersCash({commit}) {
    var auth = JSON.parse(sessionStorage.getItem('auth'))
    if (auth && auth.user.role === role) {
      commit('login', auth)
    }
  },
  login({commit}, credentials) {
    return userService.login(credentials.email, credentials.password, role)
      .then(res => {
        sessionStorage.setItem('auth', JSON.stringify(res))
        commit('login', res)
      })
      .catch(errObj => Promise.reject(errObj))
  },
  logout({commit}, credentials) {
    commit('logout')
    router.push('/login')
    sessionStorage.clear()
    return userService.logout()
  },
  createClient({ commit }, clientData) {
    const createUserType = 'createClient'
    let client

    return userService[createUserType](clientData)
      .then(resUser => {
        client = resUser
        // Read the comment in mutations
        // commit(createUserType, client)
        return portfolioService.createPortfolio(client.id, clientData.portfolioId)
      })
      .then(resPortdolioID => {
        client.portfolios = [resPortdolioID]
        return client
      })
      .catch(errObj => Promise.reject(errObj))
  },
  createUser({ commit }, user) {
    const createUserType = 'createUser'

    return userService[createUserType](user)
      .then(resUser => {
        // Read the comment in mutations
        // commit(createUserType, resUser)
        return resUser
      })
      .catch(errObj => Promise.reject(errObj))
  },
  getUsers({ commit }, {page, itemsPerPage}) {
    page = page || 1
    const limit = itemsPerPage || 20
    const offset = limit * (page - 1)

    return userService.getUsers(offset, limit)
      .then(({users, total}) => {
        commit('setUsers', {users, total, page})
        return {users, total}
      })
      .catch(errObj => Promise.reject(errObj))
  },
  getClients({ commit }, {page, itemsPerPage}) {
    page = page || 1
    const limit = itemsPerPage || 20
    const offset = limit * (page - 1)

    return userService.getClients(offset, limit)
      .then(({users, total}) => {
        commit('setClients', {users, total, page})
        return {users, total}
      })
      .catch(errObj => Promise.reject(errObj))
  },
  getClient({ commit }, clientId) {
    return userService.getUser(clientId)
      .then(client => {
        commit('setClient', client)
        return client
      })
      .catch(errObj => Promise.reject(errObj))
  },
  setClient({ commit }, client) {
    commit('setClient', client)
    return Promise.resolve(client)
  },
  updateClientGroups({ commit }, {id, cgroups}) {
    return userService.updateClientGroups(id, cgroups)
      .then(() => {
        commit('setClientGroups', cgroups)
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/-service-app/store/modules/usersStore.js